<template>
    <div>
        <v-toolbar flat dense height="35">
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        depressed
                        color="primary"
                        class="text-truncate"
                        max-width="150px"
                    >
                        {{ currentMeter ? currentMeter.name : 'Medidor' }}
                        <v-icon x-small>mdi-chevron-down</v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item
                        v-for="m in meters"
                        :key="m.id"
                        dense
                        class="text-caption"
                        @click="selectMeter(m)"
                    >
                        {{ m.name }}
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn-toggle mandatory color="accent">
                <v-btn x-small color="white" @click="type = 'power'">
                    Power
                </v-btn>
                <v-btn x-small color="white" @click="type = 'irms'">
                    Current
                </v-btn>
            </v-btn-toggle>
        </v-toolbar>
        <v-divider></v-divider>
        <v-toolbar dense flat class="">
            <v-btn
                v-if="type !== 'custom'"
                @click="before"
                icon
                x-small
                class="mr-3"
            >
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-spacer class="d-flex">
                <div class="mx-auto" v-if="this.data.categories.length !== 0">
                    <p class="text-center text-caption font-weight-medium my-0">
                        {{
                            this.data.categories[0].toLocaleDateString()
                        }}
                    </p>
                    <div class="d-flex text-caption font-weight-medium">
                        <p class="my-0">
                            {{
                                this.data.categories[0].toLocaleTimeString()
                            }}
                        </p>
                        <v-icon small class="mx-1">mdi-arrow-left-right</v-icon>
                        <p class="my-0">
                            {{
                                this.data.categories[
                                    this.data.categories.length - 1
                                ].toLocaleTimeString()
                            }}
                        </p>
                    </div>
                </div>
            </v-spacer>
            <v-btn
                v-if="type !== 'custom'"
                @click="next"
                icon
                x-small
                class="ml-3"
            >
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text
            class="pa-0"
            style="height: 40vh"
            :class="{ 'd-flex': !loaded }"
        >
            <Chart
                v-if="loaded"
                :data="data"
                freq="minutes"
                type="line"
                :defaultColors="true"
                :showXaxis="false"
                :ytitle="ytitles[this.type]"
                style="height: 40vh"
            />
            <v-progress-circular
                v-else
                indeterminate
                size="50"
                color="accent"
                class="ma-auto"
            ></v-progress-circular>
        </v-card-text>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import Chart from '../../graphs/Chart'
export default {
    name: 'RealtimeGraph',
    props: ['gateway', 'meters'],
    components: { Chart },
    data() {
        return {
            currentMeter: null,
            type: 'power',
            description: '',
            dataFormated: {},
            data: {
                categories: [],
                series: [],
            },
            pagination: {
                page_step: 30,
                page_size: 100,
                currentInit: 0,
                currentEnd: 0,
            },
            ytitles: {
                power: 'WATTS',
                irms: 'AMPS',
                pf: 'PF'
            },
            loaded: false,
        }
    },
    methods: {
        ...mapActions({
            getData: 'meters/queryReadings',
        }),
        selectMeter(meter) {
            this.currentMeter = meter
            this.data.categories = []
            this.data.series = []
            this.formatData()
        },
        async setGraphData(end) {
            this.loaded = false
            this.data.categories = []
            this.data.series = []

            let init = end - this.pagination.page_size
            if (init < 0) {
                init = 0
                end = init + this.pagination.page_size
            }

            this.pagination.currentInit = init
            this.pagination.currentEnd = end

            const data = this.dataFormated[this.type]
            const lines = Object.keys(data)
            
            this.data.categories = this.dataFormated.categories.slice(init, end)

            lines.forEach((line) => {
                this.data.series.push({
                    name: line,
                    data: data[line].slice(init, end),
                })
            })

            this.loaded = true
        },
        async formatData() {
            this.loaded = false

            const start = new Date()
            start.setHours(0, 0, 0, 0)
            const end = new Date()
            end.setDate(start.getDate() + 1)
            end.setHours(0, 0, 0, 0)

            const measures = await this.getData({
                meter: this.currentMeter.id,
                query: { len: 1440, start, end },
            })

            const data = measures.data.data
            const lines = { irms: {}, power: {}, pf: {}, categories: [] }
            const propsToShow = ['irms', 'power', 'pf']

            data.forEach((measure) => {
                const time = new Date(measure.timestamp)
                const measurement = measure.data.measurement
                const props = Object.keys(measurement)
                props.forEach((prop) => {
                    for (const propToCheck of propsToShow) {
                        if (prop.startsWith(propToCheck)) {
                            const line = `line${prop.replace(propToCheck, '')}`
                            const value = measurement[prop].toFixed(2)
                            if (Array.isArray(lines[propToCheck][line]))
                                lines[propToCheck][line].push(parseFloat(value))
                            else lines[propToCheck][line] = [parseFloat(value)]
                            break
                        }
                    }
                })

                lines.categories.push(time)
            })

            this.dataFormated = lines
            this.loaded = true
            this.setGraphData(this.dataFormated.categories.length - 1)
        },
        before() {
            let new_end = this.pagination.currentEnd - this.pagination.page_step
            if (new_end < 0) new_end = 0
            this.setGraphData(new_end)
        },
        next() {
            let new_end
            const currentEnd = this.pagination.currentEnd
            const page_step = this.pagination.page_step
            const len = this.dataFormated.categories.length

            if (currentEnd + 1 > len) return
            if (currentEnd + page_step > len) {
                new_end = len
                this.setGraphData(new_end)
                return
            }

            new_end = currentEnd + page_step
            this.setGraphData(new_end)
        },
        refresh(){
            if (this.meters.length === 0) return
            this.currentMeter = this.meters[0]
            this.formatData()
        }
    },
    watch: {
        type() {
            this.setGraphData(this.pagination.currentEnd)
        },
        gateway() {
            this.refresh()
        }
    },
    mounted() {
        this.refresh()
    },
}
</script>
